<wbo-edit-grid [data]="model.data[fieldName]" [editable]="true" [removable]="true" [entityPath]="fieldName" [title]="'wbo.report.product-barcode-selection.title'">
    <wbo-text-column field="name" [title]="'wbo.report.product-barcode-selection.column.name'"></wbo-text-column>
    <wbo-text-column field="barcode" [title]="'wbo.report.product-barcode-selection.column.barcode'"></wbo-text-column>
    <wbo-numeric-column *ngIf="editQty" field="qty" [title]="'wbo.report.product-barcode-selection.column.qty'" [editable]="true"></wbo-numeric-column>
    <wbo-edit-grid-add-row [customAdd]="true">
        <wbo-edit-grid-add-row-quick-add (onSelect)="addFromProduct([$event])">
            <wbo-product-barcode-single-select-edit-control></wbo-product-barcode-single-select-edit-control>
        </wbo-edit-grid-add-row-quick-add>
        <wbo-edit-grid-add-row-actions>
            <wbo-edit-grid-add-row-search [searchComponent]="ProductBarcodeSearchPageComponent" (onSelect)="addFromProduct($event)"></wbo-edit-grid-add-row-search>
        </wbo-edit-grid-add-row-actions>
    </wbo-edit-grid-add-row>
</wbo-edit-grid>
